// General & Report by unit
export const all = 'Todo'
export const save = 'CERRAR'
export const overDays = 'Para continuar, el periodo de tiempo debe ser entre 1 y 7 días'
export const specificUnits = 'Buscar por unidad'
export const specificValue = 'Buscar por valor'
export const search = 'Buscar'
export const unitReport = 'Reporte de Diesel por Unidad'
export const driverReport = 'Reporte de Diesel por Operador'
export const mPGAvg = 'MPG (Promedio)'
export const mPGCur = 'MPG (Último día)'
export const change = 'Cambio'
export const fuelOne = 'Tanque 1'
export const fuelTwo = 'Tanque 2'
export const lastUpdated = 'Última Actualización'
export const refresh = 'Refrescar'
export const refreshLabel = 'Refrescar'
export const driver = 'Operador'
export const utilization = 'Porcentaje de utilización'
export const viewDrivers = 'Paradas'
export const viewUnits = 'Ver Unidades'
export const parkingsReport = 'Reporte Diesel por Unidad'
export const typeUnit = 'Buscar por unidad...'
export const unitName = 'Nombre'
export const startDate = 'Fecha de inicio:'
export const endDate = 'Fecha de finalización:'
export const unit = 'Unidad'
export const totalMiles = 'Total de Millas (mi)'
export const dieselPerformance = 'Rendimiento de Diesel (mi/gal)'
export const hoursOff = 'Horas Apagado (hrs)'
export const fuelTank= 'Tanque %'
export const fuelConsumedParked = 'Combustible Consumido en Parada (gal)'
export const parkedTime = 'Tiempo de Parada (hrs)'
export const totalDieselConsumed = 'Diesel Total Consumido (gal)'
export const updatedAt = 'Ultima Act.'
export const RAM = 'MX'
export const ZARO = 'USA'
export const dialogAtentTitle = 'Atención'

// Active Trip
export const activeTripsReport = 'Reporte Diesel - Viajes Activos'
export const activeTrips = 'Viajes activos'
export const idTrip = 'ID del Viaje'
export const truck = 'Camión'
export const driverName = 'Operador'
export const trailerName = 'Caja'
export const reference = 'Referencia'
export const distance = 'Distancia(mi)'
export const lastWeekDieselPerformance = 'Rend. Ult. Semana'
export const gal = 'Diesel(gal)'

// Geofences
export const titleCreateGeofence = 'Crear geocerca'
export const titleIndexGeofence = 'Geocercas'
export const viewMoreGeofence = 'Ver mapa / Editar'
export const deleteGeofenceBtn = 'Eliminar'
export const pointGeoLabel = 'Punto #'
export const coordinates = 'Coordenadas'
export const dialogDeleteGeoTitle = '¿Deseas eliminar la geocerca con los siguientes datos?'
export const deleteGeofBtn = 'Eliminar'
export const backGeofBtn = 'No, regresar'
export const titleEditGeofence = 'Editar geocerca'
export const geofenceDeletedChip = 'Eliminado'
export const seeGeofAndTrucks = 'Ver geocer / unidades'
export const geofencesAndTrucksTitle = 'Mapa de camiones y geocercas'
export const mapNight = "Oscuro"
export const mapBasic = 'Clásico'
export const mapSatellite = 'Satelital'
export const mapRefreshTruckLocations = 'Actualizar ubicación de unidades'
export const showOnlyUnitsInGeofences = 'Solo mostrar unidades en geocerca(s)'

export const lblFilterByType = "Filtrar por tipo (Muestra todos por defecto)"
export const lblFilterByErased = "Filtrar activas/eliminadas (Muestra todos por defecto)"

export const titleGeoReactivate = "¿Desea activar la geocerca y guardar sus cambios?"
export const optGeoReCancel = "Cancelar"
export const optGeoReActivateAndSave = "Activar y guardar cambios"
export const optGeoReJustSave = "No, solo actualizar"

export const pagItemsPerPage = "Items por página"

// Geofences API notifications
export const ntGeoTitleSaved = 'Geocerca Guardada'
export const ntGeoMeSaved = 'Ahora puedes verla aquí...'

export const ntGeoTitleDupl = 'Nombre ya existente'
export const ntGeoMeDupl = 'Por favor, escribe un nombre distinto para continuar'

export const ntGeoTitleInvPoints = 'Geopuntos Inválidos'
export const ntGeoMeInvPoints = 'Por favor traza una geocerca con puntos válidos'

export const ntGeoTitleError = 'La geocerca no fue guardada'
export const ntGeoMeError = "Por favor verifica tu conexión"

export const ntGeoTitleDeleted = 'Geocerca eliminada'
export const ntGeoTitleDelError = 'Geocerca no eliminada, verifica tu conexión...'

// Geofences table headers
export const thGeoName = 'Nombre'
export const thGeoType = 'Tipo'
export const thGeoCreatedAt = 'Creado en'
export const thGeoUpdatedAt = 'Actualizado en'
export const thGeoOptions = 'Opciones'

// Sidebar
export const sbByUnitSec = 'Rep. Diesel Por Unidad'
export const sbActiveTripsSec = 'Rep. Por Viajes Activos'
export const sbGeofencesSec = 'Geocercas'

export const sbHome = 'Inicio'
export const sbConfiguration = 'Configuración'
export const sbFinalizedTrips = 'Viajes finalizados'
export const sbMailingList = 'Lista de correos'
export const sbCloseSession = 'Cerrar Sesión'

// Units list of geofence component
export const unListTitle = 'Unidades en'
export const unListNoUnitsInGeo = 'No hay unidades en'
export const unListItemUnitName = 'Camión:'
export const unListItemAddress = 'Dirección:'
export const unListItemLastUpdate = 'Última act:'

// Geofence list component
export const geoListTitle = 'Geocercas en mapa'
export const geoListItemName = 'Nombre:'
export const geoLitsItemType = 'Tipo:'

// Geofence Map Component
export const saveGeofence = 'Guardar geocerca'
export const activateOrSaveGeofence = 'Activar / Guardar geocerca'
export const goToGeofencesIndex = 'Regresar'
export const singleSearchMap = 'Busca una dirección o lugar...'
export const geofenceNotSelected = 'Datos incompletos'
export const geofenceNotSelMsg = "Por favor, para continuar, dibuja una geocerca y dale un nombre, posteriormente puedes presionar el botón de guardar"
export const geofenceNotSelConfirm = 'Ok, Perfecto'

// Truck depreciation Component
export const truckDepreciation = "Depreciación de unidades";
export const exit = "Salir";
export const selectFilePLaceholder = "Seleccionar archivo";
export const calculateNowLbl = "Calcular ahora";
export const depreciationCountTime = "Tiempo de depreciación contable";

// Login component
export const lgWelcome = 'Bienvenido'
export const lgUser = 'Usuario'
export const lgPass = 'Contraseña'
export const lgLogin = 'Ingresar'
export const lgUserRequired = 'Ingresa tu usuario para continuar'
export const lgPassRequired = 'Ingresa tu contraseña para continuar'
export const lgAuthFailTitle = 'Algo salió mal...'
export const lgAuthFailMsg = 'Revisa tus credenciales y conexión a internet'
export const lgAuthSuccessTitle = 'Hey!'
export const lgAuthSuccessMsg = 'Es un placer tenerte de vuelta'
export const lgAuthCloseTitle = 'Hasta luego'
export const lgAuthCloseMsg = 'Te esperamos pronto'

// Dashboard component
export const dashWelcome = 'Bienvenido'
export const dashFinalizedTrips = 'Viajes finalizados'
export const dashBranches = 'Oficinas'
export const dashSelectAll = 'Seleccionar todo'
export const dashUnselectAll = 'Desmarcar todo'
export const dashMore = 'más'

// Details page
export const dtlsTitle = 'Viaje'
export const dtlsTruckData = 'Información del tractor'
export const dtlsTrailerData = 'Información de la caja'
export const dtlsTruck = 'Tractor'
export const dtlsTrailer = 'Caja'
export const dtlsLatitude = 'Latitud'
export const dtlsLongitude = 'Longitud'
export const dtlsAddress = 'Dirección'
export const dtlsLastUpdate = 'Última actualización'
export const dtlsRoute = 'Ruta'
export const dtlsNoData = 'Sin datos disponibles'

export const stsTitle = 'Estado de entrega'
export const stsConfirmed = 'Confirmado'
export const stsOriginArrived = 'Llegado a origen'
export const stsOriginLoaded = 'Cargando en origen'
export const stsDestinyArrived = 'Llegado a destino'
export const stsDestinyDownloading ='Descargando en destino'
export const stsFinalizedTrip = 'Viaje finalizado'
export const stsAt = 'a las'

// Dashboard table headers
export const hDetails = 'Detalles'
export const hProgress = 'Progreso'
export const hPlannedDelivery = 'Entrega planeada'
export const hTopArrowDetails = 'Presione la flecha superior para ver los detalles del viaje'
export const hOpenSealChanges = 'Ver cambios'
export const hByTime = 'Registros por tiempo'
export const hRoute = 'Ver ruta'
export const hSeeActivity = 'Ver actividad'
export const hSeeDetails = 'Ver detalles'
export const hEstimated = 'Estimado'
export const hLoadingItems = 'Obteniendo datos, espera un momento...'
export const hSearch = 'Buscar'
export const hReference = 'Referencia'
export const hTrip = 'Viaje'
export const hShipFrom = 'Viaje de'
export const hShipTo = 'Viaje para'
export const hTruck = 'Tractor'
export const hTrailer = 'Caja'
export const hDriver = 'Operador'
export const hDriverActivity = 'Actividad del operador'
export const hTime = 'Hora'
export const hSealChanges = 'Cambios de sello'
export const hProofDelivery = 'Prueba de entrega'
export const hInvoice = 'Factura'
export const hRowsPerPage = 'Filas por página'

// File not found component
export const fnfMessage = 'El archivo que buscas no está aquí'
export const fnfOkBtn = 'De acuerdo'

// Seal changes component
export const schsTitle = 'Cambios de sello'
export const schsTrip = 'Viaje'
export const schsSeal = 'Sello'
export const schsDriver = 'Operador'
export const schsCreatedAt = 'Fecha de creación'
export const schsActions = 'Acciones'
export const schsSeeSealImage = 'Ver imagen de sello'

// Working on page
export const workingOnTitle = 'Página en construcción, regresemos...'

// Notifications settings
export const notSetTitle = 'Configurar notificaciones'
export const notSetTrip = 'Viaje'
export const notSetLada = 'Lada'
export const notSetDefaultNumbers = 'Teléfonos por defecto'
export const notSetTripNumbers = 'Números del viaje'
export const notSetPhone = 'Teléfono'
export const notSetClose = 'Cerrar'
export const notSetSave = 'Guardar'
export const notSetGeneral = 'General'
export const notSetNotifications = 'Notificaciones'
export const notSetNotificationsMsg = 'Te mantendremos al tanto del estado de tus viajes a través de Whatsapp'
export const notSetNotificationsTelMsg = 'Escribe los teléfonos donde recibirás las notificaciones de todos tus viaje'
export const notSetSavedTitle = 'Listo'
export const notSetSavedMsg = 'Se han guardado los cambios' 
export const notSetWrongPhoneMsg = 'Los siguientes números contienen errores:'
export const notSetAddBefore = 'Añade al menos un número telefónico para continuar'
export const notSetAdd = 'Agregar'

// 404 Page
export const nfTitle = "...Ups! 404 Página no encontrada"
export const nfGoHome = "Ir a inicio"
export const timeDepreciationContable = 'Tiempo de depreciación contable'
export const taxDepreciationContable = 'Tiempo de depreciación fiscal'
export const columnCostAcquisition = 'Columna monto adquisición'
export const columnDateAcquisition = 'Columna fecha adquisición'
export const dateDepreciation = 'Fecha depreciación'
export const fileData = 'Datos del archivo'

